const STORAGE_KEY = 'nt7east:delivery-location';
const UPDATE_EVENT = 'nt7east:delivery-location-updated';

function readStoredLocation() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.city === 'string' && parsed.city.trim()) {
      return parsed;
    }
  } catch (error) {
    // Storage unavailable (private browsing, etc.) - silently fall back to the server-rendered default.
  }
  return null;
}

function writeStoredLocation(city, zip) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ city, zip, source: 'manual' }));
  } catch (error) {
    // Ignore storage failures; the update still applies for the current page view.
  }
}

class DeliveryLocationWidget extends HTMLElement {
  connectedCallback() {
    this.cityEl = this.querySelector('[data-delivery-location-city]');
    this.zipEl = this.querySelector('[data-delivery-location-zip]');
    this.openButton = this.querySelector('[data-delivery-location-open]');
    this.cancelButton = this.querySelector('[data-delivery-location-cancel]');
    this.dialog = this.querySelector('[data-delivery-location-dialog]');
    this.form = this.querySelector('[data-delivery-location-form]');

    this.openButton?.addEventListener('click', () => this.openDialog());
    this.cancelButton?.addEventListener('click', () => this.dialog?.close());
    this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
    window.addEventListener(UPDATE_EVENT, (event) => this.applyLocation(event.detail, { broadcast: false }));

    const stored = readStoredLocation();
    if (stored) {
      this.applyLocation(stored, { broadcast: false });
    }
  }

  openDialog() {
    if (!this.dialog) return;
    const cityInput = this.form?.elements.namedItem('city');
    const zipInput = this.form?.elements.namedItem('zip');
    if (cityInput) cityInput.value = this.cityEl?.textContent?.trim() ?? '';
    if (zipInput) zipInput.value = this.zipEl?.textContent?.trim() ?? '';
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const formData = new FormData(this.form);
    const city = String(formData.get('city') || '').trim();
    const zip = String(formData.get('zip') || '').trim();
    if (!city) return;

    writeStoredLocation(city, zip);
    this.applyLocation({ city, zip });
    this.dialog?.close();
  }

  applyLocation(detail, { broadcast = true } = {}) {
    if (!detail || !detail.city) return;
    if (this.cityEl) this.cityEl.textContent = detail.city;
    if (this.zipEl) this.zipEl.textContent = detail.zip || '';

    if (broadcast) {
      window.dispatchEvent(new CustomEvent(UPDATE_EVENT, { detail }));
    }
  }
}

if (!customElements.get('delivery-location-widget')) {
  customElements.define('delivery-location-widget', DeliveryLocationWidget);
}
